module.exports = __webpack_public_path__ + "static/media/cover.tablet.7dd3d2f7.png";